import React, { useEffect } from 'react';

import { navigate, RouteComponentProps } from '@reach/router';

import { useGetPlayerEvent } from '../../../../contrib/Hooks/useGetPlayerEvent';

interface IProps extends RouteComponentProps {
  eventId: number;
  holeIndex: number;
  roundId: number;
}

const HoleSectionBifurcation = (props: IProps) => {
  const { eventId, holeIndex, roundId } = props;

  const event = useGetPlayerEvent(String(eventId));

  useEffect(() => {
    if (event && roundId && eventId) {
      const ctpFormat = event.formats.find(f => f.format.prefix === 'ctp');

      const holeIsCTP =
        ctpFormat &&
        ctpFormat.metadata &&
        ctpFormat.metadata[Number(roundId)] &&
        ctpFormat.metadata[Number(roundId)].includes(Number(holeIndex));

      const section = holeIsCTP ? 'selectctpwinner' : 'editor';

      navigate(`/event-scores/${eventId}/round/${roundId}/hole/${holeIndex}/${section}`);
    }
  }, [event, roundId, eventId, holeIndex]);

  return <></>;
};

export default HoleSectionBifurcation;
